import { useDispatch } from "react-redux"

import { AppDispatch } from "../redux/store"

// Typed version of redux `useDispatch` hook
export const useAppDispatch: () => AppDispatch = useDispatch
